import React, { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Spinner from "../../Spinner/spinner";
import { Button, Alert, Badge } from "reactstrap";
import { Helmet } from "react-helmet";
import { localeEs } from "../../locale/ag-grid-es";
import BreadCrum from "../../breadCrum/breadCrum";
import withTokenCheck from "../../withTokenCheck";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const AppActualizacionInformacion = ({ token }) => {
    // Estados para los dos archivos Excel
    const [dataValidacion, setDataValidacion] = useState([]);
    const [dataCombinada, setDataCombinada] = useState([]);

    const fileValidacionRef = useRef(null);
    const gridApi = useRef(null);

    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState({ show: false, type: "", message: "" });
    const [hasChanges, setHasChanges] = useState(false);
    const [archivosCargados, setArchivosCargados] = useState({
        validacion: false,
    });

    const etiquetas = [
        "Inicio Lossman",
        "Cambios De Evento",
        "Cargue de información transportes",
    ];

    const mostrarAlerta = (type, message) => {
        setAlert({ show: true, type, message });
        setTimeout(() => {
            setAlert({ show: false, type: "", message: "" });
        }, 5000);
    };


    // Procesar Excel de datos de transporte
    const handleFileValidacion = (e) => {
        const file = e.target.files[0];
        if (!file || !validarArchivoExcel(file)) return;

        setLoading(true);
        const reader = new FileReader();

        reader.onload = (evt) => {
            try {
                const wb = XLSX.read(evt.target.result, { type: "binary" });
                const ws = wb.Sheets[wb.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(ws, { header: 1 });

                if (jsonData.length < 2) {
                    mostrarAlerta("warning", "El archivo está vacío");
                    return;
                }

                procesarArchivoUnico(jsonData); // <-- aquí reemplaza a combinarDatos

                setArchivosCargados({ validacion: true });
                mostrarAlerta("success", `${jsonData.length - 1} registros cargados`);

            } catch (error) {
                mostrarAlerta("danger", "Error al procesar el archivo");
            } finally {
                setLoading(false);
            }
        };

        reader.readAsBinaryString(file);
    };

    const validarArchivoExcel = (file) => {
        const validExtensions = ['.xlsx', '.xls'];
        const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

        if (!validExtensions.includes(fileExtension)) {
            mostrarAlerta("danger", "Por favor, selecciona un archivo Excel válido (.xlsx o .xls)");
            return false;
        }
        return true;
    };

    const formatearHora = (valor) => {
        if (!valor) return "";
        // Si llega como decimal (ej: 0.25 = 06:00)
        if (typeof valor === "number" && valor < 1) {
            const totalMinutos = Math.round(valor * 24 * 60);
            const horas = Math.floor(totalMinutos / 60).toString().padStart(2, "0");
            const minutos = (totalMinutos % 60).toString().padStart(2, "0");
            return `${horas}:${minutos}`;
        }
        return String(valor).trim();
    };

    const formatearFechaHora = (valor) => {
        if (!valor) return null;

        const pad = (n) => String(n).padStart(2, "0");

        // ✅ Caso: serial numérico de Excel (ej: 46125 → 2026-04-13)
        if (typeof valor === "number") {
            const utcMs = (valor - 25569) * 86400 * 1000; // offset al epoch Unix
            const date = new Date(utcMs);
            // getUTC* evita que el offset -5 de Colombia desfase el día
            const y = date.getUTCFullYear();
            const mo = pad(date.getUTCMonth() + 1);
            const d = pad(date.getUTCDate());
            return `${y}-${mo}-${d} 00:00:00`;
        }

        // Caso: string "DD/MM/YYYY ..."
        if (typeof valor === "string") {
            const match = valor.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
            if (match) {
                const [, d, mo, y] = match;
                return `${y}-${pad(mo)}-${pad(d)} 00:00:00`;
            }
        }

        // Caso: Date object
        if (valor instanceof Date) {
            const y = valor.getUTCFullYear();
            const mo = pad(valor.getUTCMonth() + 1);
            const d = pad(valor.getUTCDate());
            return `${y}-${mo}-${d} 00:00:00`;
        }

        return null;
    };

    const procesarArchivoUnico = (jsonData) => {
        const rows = jsonData.slice(1); // Saltar encabezados

        const procesado = rows.map((row, index) => {
            return {
                id: `reg_${index + 1}`,
                Hogar: String(row[0] || "").trim(),
                FechaServicio: formatearFechaHora(row[1]) ?? "",
                TipoServicio: String(row[2]),
                RutaTraslado: String(row[5] || "").trim(),
                NombrePaciente: String(row[3] || "").trim(),
                NumeroContacto: String(row[4] || "").trim(),
                HoraCita: formatearHora(row[6]) ?? "",
                HoraSalida: formatearHora(row[7]) ?? "",
                Obervacion: String(row[8] || "").trim(),
                Conductor: String(row[9] || "").trim(),
                Vehiculo: String(row[10] || "").trim(),
                DetalleTransporteExt: String(row[11] || "").trim(),
                NumeroSolicitud: String(row[12] || "").trim(),
                NumeroAcompanantes:   String(row[13] ?? "0").trim(),
                NumeroDocumento: String(row[14] || "").trim(),
                NumeroPacientes: String(row[15] || "").trim(),
                NumeroAcompanante: String(row[16] || "").trim(),
                NumeroAlimentacion: String(row[17] || "").trim(),
                IdReferencia: String(row[18] || "").trim(),
            };
        });

        setDataCombinada(procesado);
        setHasChanges(true);
    };


    const descargarArchivoErrores = (contenido, nombreArchivo = 'errores_carga_informacion.txt') => {
        const blob = new Blob([contenido], { type: 'text/plain;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = nombreArchivo;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleGuardarDatos = async () => {
        if (!hasChanges || dataCombinada.length === 0) {
            mostrarAlerta("warning", "No hay datos para guardar");
            return;
        }

        // Validar que al menos un archivo esté cargado
        if (!archivosCargados.validacion) {
            mostrarAlerta("warning", "Debes cargar al menos un archivo antes de guardar");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                "formulario/viajes/cargar",
                {
                    registros: dataCombinada,
                    archivosCargados: archivosCargados
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                }
            );

            // Construir el HTML para mostrar los resultados detallados
            const resultados = response.data.resultados;
            const archivoErrores = response.data.archivoErrores;
            let htmlContent = '<div style="text-align: left;">';

            // Información de validación
            if (archivosCargados.validacion) {
                htmlContent += `
                    <div style="margin-bottom: 15px;">
                        <strong>📋 Validación:</strong>
                        <ul style="margin: 5px 0;">
                            <li>Intentados: ${resultados.validacion.intentados}</li>
                            <li>Exitosos: <span style="color: green;">${resultados.validacion.exitosos}</span></li>
                            <li>Fallidos: <span style="color: red;">${resultados.validacion.fallidos}</span></li>
                        </ul>
                    </div>
                `;
            }

            // Total de registros
            htmlContent += `
                <div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #ddd;">
                    <strong>Total de registros procesados: ${dataCombinada.length}</strong>
                </div>
            `;

            // Mostrar errores si los hay
            const totalErrores = (resultados.validacion.errores?.length || 0);

            if (totalErrores > 0) {
                htmlContent += `
                    <div style="margin-top: 10px; color: #d32f2f;">
                        ⚠️ Se encontraron ${totalErrores} errores. Revisa la consola para más detalles.
                    </div>
                `;
                console.log('Errores de validación:', resultados.validacion.errores);
            }

            htmlContent += '</div>';

            setLoading(false);

            const result = await Swal.fire({
                icon: "success",
                title: "¡Datos Guardados!",
                html: htmlContent,
                showCloseButton: true,
                confirmButtonText: "Aceptar",
                showDenyButton: archivoErrores ? true : false,
                denyButtonText: archivoErrores ? '📥 Descargar Reporte de Errores' : undefined,
                denyButtonColor: '#f44336',
                width: 600,
            });

            if (result.isDenied && archivoErrores) {
                const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
                descargarArchivoErrores(archivoErrores, `errores_carga_${timestamp}.txt`);

                Swal.fire({
                    icon: 'info',
                    title: 'Reporte Descargado',
                    text: 'El reporte de errores se ha descargado correctamente.',
                    timer: 2000,
                    showConfirmButton: false
                });
            }

            setHasChanges(false);
            limpiarDatosSilencioso();
            mostrarAlerta("success", response.data.message);

        } catch (error) {

            const errorData = error.response?.data; const
                archivoErrores = errorData?.archivoErrores;
            let htmlError = '<div style="text-align: left;">';

            if (errorData?.resultados) {
                const resultados = errorData.resultados;

                htmlError += `<p><strong>Detalles del error:</strong></p>`;

                // Mostrar errores de validación
                if (resultados.validacion?.errores?.length > 0) {
                    htmlError += `<div style="margin: 10px 0;"><strong>Errores de Validación:</strong><ul>`;
                    resultados.validacion.errores.slice(0, 5).forEach(err => {
                        htmlError += `<li>Caso ${err.caso}: ${err.error}</li>`;
                    });
                    if (resultados.validacion.errores.length > 5) {
                        htmlError += `<li>... y ${resultados.validacion.errores.length - 5} errores más</li>`;
                    }
                    htmlError += `</ul></div>`;
                }
            } else {
                htmlError += `<p>${errorData?.message || error.message || "Error desconocido"}</p>`;
            }

            htmlError += '</div>';

            setLoading(false);

            const result = await Swal.fire({
                icon: "error",
                title: "Error al Guardar",
                html: htmlError,
                showCloseButton: true,
                confirmButtonText: "Entendido",
                showDenyButton: archivoErrores ? true : false,
                denyButtonText: archivoErrores ? '📥 Descargar Reporte Completo de Errores' : undefined,
                denyButtonColor: '#f44336',
                width: 600,
            });

            // Si el usuario hace clic en "Descargar Reporte Completo de Errores"
            if (result.isDenied && archivoErrores) {
                const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
                descargarArchivoErrores(archivoErrores, `errores_criticos_${timestamp}.txt`);

                Swal.fire({
                    icon: 'info',
                    title: 'Reporte Descargado',
                    text: 'El reporte completo de errores se ha descargado correctamente.',
                    timer: 2000,
                    showConfirmButton: false
                });
            }

            limpiarDatosSilencioso();
            mostrarAlerta("danger", errorData?.message || "Error al guardar los datos");
        } finally {
            setLoading(false);
        }
    };

    const limpiarDatosSilencioso = () => {
        setDataValidacion([]);
        setDataCombinada([]);
        setHasChanges(false);
        setArchivosCargados({ validacion: false });

        if (fileValidacionRef.current) fileValidacionRef.current.value = "";
    };


    const handleLimpiarDatos = () => {
        if (window.confirm("¿Estás seguro de limpiar todos los datos cargados?")) {
            setDataValidacion([]);
            setDataCombinada([]);
            setHasChanges(false);
            setArchivosCargados({ validacion: false });

            if (fileValidacionRef.current) fileValidacionRef.current.value = "";

            mostrarAlerta("info", "Datos limpiados correctamente");
        }
    };


    const onGridReady = (params) => {
        gridApi.current = params.api;
    };

    const defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        flex: 1,
        minWidth: 120,
    };

    // Cell renderer para mostrar de qué archivo viene cada dato

    const columnDefs = [
        {
            field: "Hogar",
            headerName: "Hogar Asignado",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "FechaServicio",
            headerName: "Fecha de Servicio",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "TipoServicio",
            headerName: "Tipo de Servicio",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "RutaTraslado",
            headerName: "Ruta de traslado",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "NombrePaciente",
            headerName: "Nombre de paciente",
            checkboxSelection: true,
            headerCheckboxSelection: true,
            pinned: 'left',
        },
        {
            field: "NumeroContacto",
            headerName: "Numero de contacto",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "HoraCita",
            headerName: "Hora de la cita",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "HoraSalida",
            headerName: "Hora de salida",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "Obervacion",
            headerName: "Observación",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "Conductor",
            headerName: "Conductor",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "Vehiculo",
            headerName: "Vehiculo",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "DetalleTransporteExt",
            headerName: "Detalle transporte Externo",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "NumeroSolicitud",
            headerName: "Numero de Solicitud",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "NumeroPacientes",
            headerName: "Paciente",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "NumeroAcompanante",
            headerName: "cantidad de Acompañantes",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "NumeroAlimentacion",
            headerName: "cantidad de Alimentación",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "NumeroDocumento",
            headerName: "Numero de Documento",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
        {
            field: "IdReferencia",
            headerName: "Asignar Conductor",
            cellStyle: params => params.value ? {} : { backgroundColor: '#ffebee' }
        },
    ];

    return (
        <>
            <Helmet>
                <title>Cargar Información</title>
            </Helmet>
            <div style={{ position: "relative" }}>
                {loading && <Spinner />}

                <div>
                    <BreadCrum etiquetas={etiquetas} />
                </div>

                {alert.show && (
                    <div className="container-fluid mt-3">
                        <Alert color={alert.type}>
                            {alert.message}
                        </Alert>
                    </div>
                )}

                <div style={{ opacity: loading ? 0.5 : 1, pointerEvents: loading ? 'none' : 'auto' }}>
                    <div className="container-fluid mt-3">

                        {/* Sección de carga de archivos */}
                        <div className="card mb-3">
                            <div className="card-body">
                                <h5 className="card-title">Cargar archivos Excel</h5>

                                {/* Archivo 1: Validación */}
                                <div className="row mb-3">
                                    <div className="col-md-12">
                                        <label className="form-label fw-bold">
                                            <i className="bi bi-file-earmark-excel"></i> Archivo de viajes
                                            {archivosCargados.validacion && (
                                                <Badge color="success" className="ms-2">Cargado ({dataValidacion.length})</Badge>
                                            )}
                                        </label>
                                        <input
                                            type="file"
                                            ref={fileValidacionRef}
                                            className="form-control"
                                            accept=".xlsx, .xls"
                                            onChange={handleFileValidacion}
                                            disabled={loading}
                                        />
                                        <small className="form-text text-muted">
                                            Columnas esperadas: [Número Caso]
                                        </small>
                                    </div>
                                </div>

                                {/* Botones de acción */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="d-flex gap-2 flex-wrap">
                                            <Button
                                                color="primary"
                                                onClick={handleGuardarDatos}
                                                disabled={!hasChanges || dataCombinada.length === 0 || loading}
                                            >
                                                <i className="bi bi-save"></i> Guardar Datos ({dataCombinada.length})
                                            </Button>
                                            <Button
                                                color="warning"
                                                onClick={handleLimpiarDatos}
                                                disabled={!hasChanges || loading}
                                            >
                                                <i className="bi bi-x-circle"></i> Limpiar Todo
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Información de registros */}
                        {dataCombinada.length > 0 && (
                            <div className="alert alert-info">
                                <div className="row">
                                    <div className="col-md-3">
                                        <strong>Total registros:</strong> {dataCombinada.length}
                                    </div>
                                    <div className="col-md-3">
                                        <strong>Con validación:</strong> {dataValidacion.length}
                                    </div>
                                    <div className="col-md-3">
                                        {hasChanges && <Badge color="warning">Sin guardar</Badge>}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Tabla AG-Grid */}
                        <div className="mt-3" style={{ height: "500px", width: "100%" }}>
                            <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>
                                <AgGridReact
                                    rowData={dataCombinada}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    onGridReady={onGridReady}
                                    localeText={localeEs}
                                    paginationPageSize={20}
                                    rowSelection="multiple"
                                    suppressRowClickSelection={true}
                                />
                            </div>
                        </div>

                        {/* Leyenda */}
                        {dataCombinada.length > 0 && (
                            <div className="mt-2">
                                <small className="text-muted">
                                    <Badge color="info">Viajes</Badge> = Datos del archivo de Viajes |
                                    <span className="ms-1" style={{ backgroundColor: '#ffebee', padding: '2px 6px' }}>Rojo</span> = Dato faltante
                                </small>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default withTokenCheck(AppActualizacionInformacion);
